export enum ReferencePeriodEnum {
  LAST_DAYS = 'LAST_DAYS',
  CUSTOM_INTERVAL = 'CUSTOM_INTERVAL',
}
